import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _validationExpireStat, _validationDocumentSt;

import { ValidationDocumentState, ValidationDocumentType, ValidationRequirementExpirationStatus, ValidationRequirementStatus } from '../shared/generated';
export var ValidationUploadFileTypeMap = {
  certificate: {
    value: ValidationDocumentType.CERTIFICATE,
    label: 'Policy Certificate'
  },
  schedule: {
    value: ValidationDocumentType.SCHEDULE,
    label: 'Policy Schedule'
  },
  unspecified: {
    value: 'unspecified',
    label: 'Unspecified'
  }
};
export var ValidationUploadFileTypeList = Object.values(ValidationUploadFileTypeMap).filter(function (item) {
  return item.value !== 'unspecified';
});
export var validationRequirementStatusMap = {
  success: {
    value: ValidationRequirementStatus.SUCCESS,
    label: 'Success'
  },
  fail: {
    value: ValidationRequirementStatus.FAIL,
    label: 'Fail'
  },
  pending: {
    value: ValidationRequirementStatus.PENDING,
    label: 'Pending'
  },
  notStarted: {
    value: ValidationRequirementStatus.NOT_STARTED,
    label: 'Not started'
  }
};
export var validationRequirementStatusList = Object.values(validationRequirementStatusMap);
export var requirementValidateTaskTypeMap = {
  worldwide: {
    value: 'worldwide',
    label: 'Worldwide'
  },
  country: {
    value: 'country',
    label: 'Country'
  }
};
export var fileExtractedRequirementResultTypeMap = {
  extracted: {
    value: 'extracted',
    label: 'Extracted'
  },
  missingData: {
    value: 'missingData',
    label: 'Missing data'
  }
};
export var validationExpireStatusMap = (_validationExpireStat = {}, _defineProperty(_validationExpireStat, ValidationRequirementExpirationStatus.EXPIRED, {
  value: ValidationRequirementExpirationStatus.EXPIRED,
  label: 'Expired'
}), _defineProperty(_validationExpireStat, ValidationRequirementExpirationStatus.EXPIRE_SOON, {
  value: ValidationRequirementExpirationStatus.EXPIRE_SOON,
  label: 'Expire soon'
}), _defineProperty(_validationExpireStat, ValidationRequirementExpirationStatus.URGENT_EXPIRING, {
  value: ValidationRequirementExpirationStatus.URGENT_EXPIRING,
  label: 'Urgent expiring'
}), _validationExpireStat);
export var validationExpireStatusList = Object.values(validationExpireStatusMap);
export var supplierMemberRoleMap = {
  admin: {
    value: 'admin',
    label: 'Admin'
  }
};
export var supplierMemberRoleList = Object.values(supplierMemberRoleMap);
export var validationDocumentStateMap = (_validationDocumentSt = {}, _defineProperty(_validationDocumentSt, ValidationDocumentState.CANCELLED, {
  value: ValidationDocumentState.CANCELLED,
  label: 'Cancelled'
}), _defineProperty(_validationDocumentSt, ValidationDocumentState.PENDING, {
  value: ValidationDocumentState.PENDING,
  label: 'Pending'
}), _defineProperty(_validationDocumentSt, ValidationDocumentState.CONFIRMED, {
  value: ValidationDocumentState.CONFIRMED,
  label: 'Confirmed'
}), _validationDocumentSt);
export var validationDocumentStateList = Object.values(validationDocumentStateMap);